import { node } from 'prop-types';
import React from 'react';

import api from '../../REST/api';
import CategoryContext from './CategoryContext';

class ProvideCategories extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = { categories: [] };
  }

  componentDidMount() {
    api.getCategories().then(categories => this.setState({ categories }));
  }

  render() {
    const { children } = this.props;
    const { categories } = this.state;

    return (
      <CategoryContext.Provider value={categories}>
        {children}
      </CategoryContext.Provider>
    );
  }
}

ProvideCategories.propTypes = { children: node.isRequired };

export default ProvideCategories;
